import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { IntlText } from "../util/Text";
import ArtistPart from "../views/ArtistPart";

class ArtistsList extends Component {
  render = () => {
    if (this.props.artists == null) {
      return (
        <div className="uk-text-center">
          <span data-uk-spinner="ratio: 3"></span>
        </div>
      );
    } else if (this.props.artists.length <= 0) {
      return (
        <div>
          <h3>
            <IntlText id="lists.artists.no" />
          </h3>
        </div>
      );
    }

    return (
      <div>
        {this.props.artists.map((artist, index) => {
          return (
            <div key={index} className="uk-margin-small">
              <ArtistPart
                artist={artist}
                onClick={(value) => {
                  this.props.onClick && this.props.onClick(value);
                }}
                editing={this.props.editing}
                lang={this.props.language.edit}
                buttonText={this.props.buttonText}
              />
            </div>
          );
        })}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ArtistsList),
);
